const MTOProductForm = (() => {
  const MIN_SQUARE_FEET = 15;
  const state = {
    apiUrl: 'http://localhost:3334',
    pricing: null,
    quantity: 1,
    dimensions: {
      width: { ft: 3, in: 0 },
      length: { ft: 5, in: 0 }
    },
    includeRugPad: false,
    rugPadPricing: null,
    productId: null
  };

  const elements = {
    form: document.getElementById('mto-product-form'),
    addToCartButton: document.getElementById('mto-add-to-cart'),
    widthFtSelect: document.getElementById('width-ft'),
    widthInchesSelect: document.getElementById('width-inches'),
    lengthFtSelect: document.getElementById('length-ft'),
    lengthInchesSelect: document.getElementById('length-inches'),
    rugPadCheckbox: document.getElementById('add-rug-pad'),
    quantityInput: document.querySelector('input[data-quantity-input]'),
    productPriceElement: document.querySelectorAll('[data-product-price]'),
    calculatedPriceElement: document.querySelector('.product__submit--mto-form [data-button-price]'),
    calculatedRugPadPriceElement: document.getElementById('calculated-rug-pad-price'),
    sizeSelector: document.querySelector('[data-select-label="Size"]'),
    rugPadSizeSelector: document.querySelector('[data-select-label="Rug Pad"]'),
  };

  const init = () => {
    loadInitialState();
    attachEventListeners();
    updateUI();
  };

  function updateDisabledOptions() {
    const widthFt = state.dimensions.width.ft;
    const widthInches = state.dimensions.width.in;
    const lengthFt = state.dimensions.length.ft;
    const lengthInches = state.dimensions.length.in;
  
    const totalWidthInFeet = widthFt + widthInches / 12;
    const totalLengthInFeet = lengthFt + lengthInches / 12;
  
    // Update length options based on selected width
    const minLengthFt = Math.ceil(MIN_SQUARE_FEET / totalWidthInFeet);
    Array.from(elements.lengthFtSelect.options).forEach(option => {
      const lengthOption = parseInt(option.value);
      option.disabled = lengthOption < minLengthFt;
    });
  
    // Update width options based on selected length
    const minWidthFt = Math.ceil(MIN_SQUARE_FEET / totalLengthInFeet);
    Array.from(elements.widthFtSelect.options).forEach(option => {
      const widthOption = parseInt(option.value);
      option.disabled = widthOption < minWidthFt;
    });
  
    // Ensure selected options are still valid
    if (lengthFt < minLengthFt) {
      elements.lengthFtSelect.value = minLengthFt;
      elements.lengthInchesSelect.value = '0'; // Reset inches
    }
    if (widthFt < minWidthFt) {
      elements.widthFtSelect.value = minWidthFt;
      elements.widthInchesSelect.value = '0'; // Reset inches
    }
  
    // Disable inch options based on current width and length
    updateInchOptions(elements.widthFtSelect, elements.widthInchesSelect, totalLengthInFeet);
    updateInchOptions(elements.lengthFtSelect, elements.lengthInchesSelect, totalWidthInFeet);
  }

  function updateInchOptions(ftSelect, inchesSelect, otherDimensionFeet) {
    const ftValue = parseInt(ftSelect.value);
    
    // If the selected feet is high enough that any inch value works, all inch options should be enabled
    const totalAreaWithCurrentFeet = ftValue * otherDimensionFeet;
    const allInchesAvailable = totalAreaWithCurrentFeet >= MIN_SQUARE_FEET;
  
    Array.from(inchesSelect.options).forEach(option => {
      const inchValue = parseInt(option.value);
      
      if (allInchesAvailable) {
        option.disabled = false;
      } else {
        // Calculate the area with the inch value and only enable inches that keep area above 15 square feet
        const totalDimensionWithInches = ftValue + inchValue / 12;
        const resultingArea = totalDimensionWithInches * otherDimensionFeet;
        option.disabled = resultingArea < MIN_SQUARE_FEET;
      }
    });
  
    // Ensure current inch value is valid
    if (parseInt(inchesSelect.value) > 11 || inchesSelect.options[parseInt(inchesSelect.value)].disabled) {
      inchesSelect.value = '0';  // Reset to 0 if current selection is invalid
    }
  }

  const loadInitialState = () => {
    const mtoPricingData = JSON.parse(document.getElementById('mto-pricing-data').textContent);
    state.pricing = {
      lt50Price: mtoPricingData.price_lt50 ? parseFloat(mtoPricingData.price_lt50) : null,
      gt50Price: mtoPricingData.price_gt50 ? parseFloat(mtoPricingData.price_gt50) : null,
      wd12Price: mtoPricingData.price_wd12 ? parseFloat(mtoPricingData.price_wd12) : null,
    };
    
    const mtoRugPadPricingData = JSON.parse(document.getElementById('mto-rug-pad-pricing-data').textContent);
    state.rugPadPricing = {
      lt50Price: mtoRugPadPricingData.price_lt50 ? parseFloat(mtoRugPadPricingData.price_lt50) : null,
      gt50Price: mtoRugPadPricingData.price_gt50 ? parseFloat(mtoRugPadPricingData.price_gt50) : null,
      wd12Price: mtoRugPadPricingData.price_wd12 ? parseFloat(mtoRugPadPricingData.price_wd12) : null,
    };
    
    state.productId = mtoPricingData.product_id;
    state.quantity = parseInt(elements.quantityInput.value);

    if (elements.sizeSelector) {
      elements.sizeSelector.classList.add('mto-hidden-option');
    }
    if (elements.rugPadSizeSelector) {
      elements.rugPadSizeSelector.classList.add('mto-hidden-option');
    }
  };

  const attachEventListeners = () => {
    elements.form.addEventListener('change', handleFormChange);
    elements.addToCartButton.addEventListener('click', handleAddToCart);
  };

  const handleFormChange = (event) => {
    const { name, value, type, checked } = event.target;
    updateState(name, type === 'checkbox' ? checked : value);
    updateUI();
  };

  const updateState = (name, value) => {
    switch (name) {
      case 'width-ft':
        state.dimensions.width.ft = parseInt(value);
        break;
      case 'width-in':
        state.dimensions.width.in = parseInt(value);
        break;
      case 'length-ft':
        state.dimensions.length.ft = parseInt(value);
        break;
      case 'length-in':
        state.dimensions.length.in = parseInt(value);
        break;
      case 'add-rug-pad':
        state.includeRugPad = value;
        break;
      case 'quantity':
        state.quantity = parseInt(value);
        break;
    }
  };

  const updateUI = () => {
    updateDisabledOptions();
    const { price, rugPadPrice } = calculatePrices();
    let totalPrice = price * state.quantity;
    if (state.includeRugPad) {
      totalPrice += rugPadPrice * state.quantity;
    }
    elements.calculatedPriceElement.textContent = `$${totalPrice.toFixed(2)}`;
    elements.productPriceElement.forEach((productPriceElement) => productPriceElement.textContent = `$${(price).toFixed(2)}`);
    elements.calculatedRugPadPriceElement.textContent = `$${rugPadPrice.toFixed(2)}`;
  };

  const calculateArea = () => {
    const width = state.dimensions.width.ft + (state.dimensions.width.in / 12);
    const length = state.dimensions.length.ft + (state.dimensions.length.in / 12);
    const area = parseFloat((width * length).toFixed(2));
    return {
      width,
      length,
      area
    }
  };

  const calculatePrices = () => {
    const {width, length, area} = calculateArea();
    let pricePerSquareFoot = state.pricing.lt50Price;
    
    if (area >= 50 && state.pricing.gt50Price) {
      pricePerSquareFoot = state.pricing.gt50Price;
    }
    
    if ((width > 12) && state.pricing.wd12Price) {
      pricePerSquareFoot = state.pricing.wd12Price;
    }
    
    let price = pricePerSquareFoot * area;
    const rugPadPrice = calculateRugPadPrice();

    return { price, rugPadPrice };
  };

  const calculateRugPadPrice = () => {
    const {width, length, area} = calculateArea();
    let pricePerSquareFoot = state.rugPadPricing.lt50Price;
    
    if (area >= 50 && state.rugPadPricing.gt50Price) {
      pricePerSquareFoot = state.rugPadPricing.gt50Price;
    }
    
    if ((width > 12) && state.rugPadPricing.wd12Price) {
      pricePerSquareFoot = state.rugPadPricing.wd12Price;
    }
    
    return parseFloat((pricePerSquareFoot * area).toFixed(2));
  };

  const handleAddToCart = async (event) => {
    event.preventDefault();
    elements.addToCartButton.disabled = true;
    elements.addToCartButton.classList.add('loading');

    try {
      const customVariant = await getCustomVariant();
      await addToCart(customVariant.rugVariantId, state.quantity);
      
      if (customVariant.rugPadVariantId) {
        await addToCart(customVariant.rugPadVariantId, state.quantity);
      }

      showSuccess(customVariant);
    } catch (error) {
      console.error('Error:', error);
      showError();
    }
  };

  const getCustomVariant = async () => {
    const options = {
      width: (state.dimensions.width.ft + state.dimensions.width.in / 12).toFixed(2),
      length: (state.dimensions.length.ft + state.dimensions.length.in / 12).toFixed(2)
    };

    const response = await fetch(state.apiUrl + '/.netlify/functions/getCustomVariant', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ productId: state.productId, options, includeRugPad: state.includeRugPad })
    });

    const data = await response.json();

    if (!data.success) {
      throw new Error(data.error || 'Failed to create variants');
    }

    return data;
  };

  const addToCart = async (variantId, quantity) => {
    const formData = {
      items: [{
        id: variantId.replace("gid://shopify/ProductVariant/", ""),
        quantity
      }]
    };

    const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(formData)
    });

    const data = await response.json();

    updateCart();

    return data;
  };

  const updateCart = async () => {
    const response = await fetch(`${window.Shopify.routes.root}cart.js`, {
      headers: { 'Content-Type': 'application/json' }
    });

    const cartData = await response.json();

    setTimeout(() => {
      document.dispatchEvent(
        new CustomEvent('theme:cart:change', {
          detail: { cart: cartData },
          bubbles: true
        })
      );
    }, 1000);
  };

  const showSuccess = (customVariant) => {
    elements.addToCartButton.classList.remove('loading');
    elements.addToCartButton.classList.add('has-success');

    document.dispatchEvent(
      new CustomEvent('theme:cart:popdown', {
        detail: {
          variant: { id: customVariant.rugVariantId.replace("gid://shopify/ProductVariant/", "") }
        },
        bubbles: true
      })
    );

    setTimeout(() => {
      elements.addToCartButton.classList.remove('has-success');
      elements.addToCartButton.disabled = false;
    }, 3500);
  };

  const showError = () => {
    elements.addToCartButton.classList.remove('loading');
    elements.addToCartButton.classList.add('has-error');

    setTimeout(() => {
      elements.addToCartButton.classList.remove('has-error');
      elements.addToCartButton.disabled = false;
    }, 3500);
  };

  return { init };
})();

try {
  document.addEventListener('DOMContentLoaded', MTOProductForm.init);
} catch (error) {
  console.error('Error initializing MTO rug calculator');
}